/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Embed_Captions_Important_TotalInputs */



/**
* | output |
* | --- |
* | "Total cost for this job will be {total}." |
*
* @param {Embed_Captions_Important_TotalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_important_total = /** @type {((inputs: Embed_Captions_Important_TotalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Important_TotalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le cout total de cette tache sera de ${i?.total}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Gesamtkosten für diesen Auftrag betragen ${i?.total}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il costo totale per questo lavoro sarà di ${i?.total}.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Общая стоимость этой работы составит ${i?.total}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El costo total de este trabajo será ${i?.total}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`这项工作的总成本为${i?.total}。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`この仕事の合計費用は${i?.total}になります。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इस कार्य की कुल लागत ${i?.total} होगी।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O custo total deste trabalho será de ${i?.total}.`)
	return /** @type {LocalizedString} */ (`Total cost for this job will be ${i?.total}.`)
});